/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  Select,
  Input,
  Spin,
  Radio,
  Typography,
  AutoComplete,
} from "antd";
import "./index.css";
import {
  CloseCircleOutlined,
  DownOutlined,
  FileExcelOutlined,
  PrinterFilled,
  SearchOutlined,
} from "@ant-design/icons";
import { BiCalendar } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import DatePicker from "react-datepicker";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import ReactToPrint from "react-to-print-advanced";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
//components & store
import { loadParties } from "../../store/parties/actions";
import {
  loadProfitLossReportList,
  loadPurchaseInvoiceRecordsMetaData,
} from "../../store/reports/actions";

const ProfitLossReport = (props) => {
  const dispatch = useDispatch();
  const media = useMedia();
  // const { RangePicker } = DatePicker;

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  const profitPayload = {
    organizationId: organizationId,
  };

  //initial state values
  const printProfitRef = useRef(null);
  const [profitMode, setProfitMode] = useState("Date Wise");
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [profitPrint, setProfitPrint] = useState(false);
  const [profitClear, setProfitClear] = useState(false);
  const [profitList, setProfitList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);

  console.log(tableLoading, "tableLoading");

  //fuse options in venue name
  const fuseOptions = {
    keys: ["saleInvoiceNo", "label"],
  };
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);

    dispatch(loadPurchaseInvoiceRecordsMetaData());
    dispatch(loadParties(profitPayload));
    dispatch(loadProfitLossReportList(profitPayload));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { profit_report_list = [] } = useSelector((state) => state.Reports);
  const { parties_list = [] } = useSelector((state) => state.Parties);

  const customerOptions =
    parties_list && parties_list.length > 0
      ? parties_list.map((data) => {
          return { value: data._id, label: data.partyName };
        })
      : [];

  //filters

  const applyFilters = () => {
    let searchObjects = {
      fromDateValue: "",
      toDateValue: "",
      customerValue: "",
      invoiceNo: "",
    };
    if (profitMode == "Invoice Wise") {
      var invoiceFilter =
        profitList && profitList.value ? profitList.value : "";
      searchObjects = {
        invoiceNo: invoiceFilter,
      };
    } else {
      var fromDateFilter = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
      var customerFilter =
        customerList && customerList.value ? customerList.value : "";
      searchObjects = {
        fromDateValue: fromDateFilter,
        toDateValue: toDateFilter,
        customerValue: customerFilter,
      };
    }

    console.log(searchObjects, "searchObjects");

    let searchValue = {};
    searchValue.organizationId = organizationId;

    if (searchObjects.fromDateValue) {
      searchValue.fromDate = searchObjects.fromDateValue;
    }
    if (searchObjects.toDateValue) {
      searchValue.toDate = searchObjects.toDateValue;
    }
    if (searchObjects.invoiceNo) {
      searchValue.saleInvoiceNo = searchObjects.invoiceNo;
    }
    if (searchObjects.customerValue) {
      searchValue.partyId = searchObjects.customerValue;
    }
    const searchFilterValues = Object.keys(searchValue).forEach(
      (data) => !searchValue[data] && delete searchValue[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
    dispatch(loadProfitLossReportList(searchValue));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const resetFilters = () => {
    setFromDate("");
    setToDate("");
    setCustomerList([]);
    dispatch(loadProfitLossReportList(profitPayload));
    // setTableLoading(true);
    // setTimeout(() => {
    //   setTableLoading(false);
    // }, 2000);
  };
  const resetInvoiceFilters = () => {
    setProfitList([]);
    dispatch(loadProfitLossReportList(profitPayload));
    // setTableLoading(true);
    setProfitClear(true);
    setTimeout(() => {
      setProfitClear(false);
    }, 0);
    // setTimeout(() => {
    //   setTableLoading(false);
    // }, 2000);
  };

  // console.log(filteredValues, "filteredValues");

  const [profitReportRows, setProfitReportRows] = useState([
    {
      key: "",
      dateCreated: "",
      saleInvoiceNo: "",
      salesInvoiceDate: "",
      modelName: "",
      partyName: "",
      purchasePrice: "",
      sellingPrice: "",
      discountAmount: "",
      returnAmount: "",
      profit: "",
      qty: "",
      _id: "",
    },
  ]);

  const profitReportDataTable =
    !isEmpty(profit_report_list) && profit_report_list.salesInvoices.length > 0
      ? profit_report_list.salesInvoices.map((data, index) => {
          return {
            key: index + 1,
            _id: data._id,
            itemId: data.itemId,
            modelName: data.modelName,
            purchasePrice: data.purchasePrice ? data.purchasePrice : 0,
            sellingPrice: data.sellingPrice ? data.sellingPrice : 0,
            discountAmount: data.discountAmount ? data.discountAmount : 0,
            returnAmount: data.returnAmount ? data.returnAmount : 0,
            profit: data.profit ? data.profit : 0,
            qty: data.qty ? data.qty : 0,
            saleInvoiceNo: data.saleInvoiceNo,
            salesInvoiceDate: data.salesInvoiceDate,
            partyName: data.partyName,
            status: data.status,
          };
        })
      : [];

  const profitReportTotalObj = profit_report_list && profit_report_list;

  const invoiceListOptions =
    profitReportDataTable.length > 0
      ? profitReportDataTable.map((data) => {
          return {
            label: data.saleInvoiceNo,
            value: data.saleInvoiceNo,
            // value: data._id,
          };
        })
      : [];

  console.log(profitReportTotalObj, "profitReportTotalObj");
  //Calculate totals
  const calculateTotals = (rows) => {
    let purchasePrice = 0;
    let sellingPrice = 0;
    let qty = 0;
    let itemDiscount = 0;
    let profit = 0;
    let returnPrice = 0;

    rows.forEach((row) => {
      purchasePrice += parseFloat(row.purchasePrice) || 0;
      sellingPrice += parseFloat(row.sellingPrice) || 0;
      qty += parseFloat(row.qty) || 0;
      itemDiscount += parseFloat(row.discountAmount) || 0;
      returnPrice += parseFloat(row.returnAmount) || 0;
      profit += parseFloat(row.profit) || 0;
    });

    return {
      purchasePrice,
      sellingPrice,
      qty,
      returnPrice,
      itemDiscount,
      profit,
    };
  };

  const [totals, setTotals] = React.useState({
    purchasePrice: 0,
    sellingPrice: 0,
    returnPrice: 0,
    qty: 0,
    itemDiscount: 0,
    totalDiscount: 0,
    profitPercent: 0,
    profit: 0,
  });

  useEffect(() => {
    if (profitReportDataTable && profitReportDataTable.length > 0) {
      setProfitReportRows(profitReportDataTable);
      const total = calculateTotals(profitReportDataTable);
      setTotals(total);
    } else {
      setProfitReportRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profit_report_list]);

  useEffect(() => {
    if (profitReportRows && profitReportRows.length > 0) {
      const total = calculateTotals(profitReportRows);
      setTotals(total);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profitReportRows]);

  // const [sortConfig, setSortConfig] = useState({
  //   key: null,
  //   direction: "asc",
  // });
  // const [renderPage, setRenderPage] = useState(false);

  // Sorting function
  // const handleSort = (key) => {
  //   let direction = "asc";
  //   if (sortConfig.key === key && sortConfig.direction === "asc") {
  //     direction = "desc";
  //   }

  //   const sortedData = [...profitReportRows].sort((a, b) => {
  //     if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
  //     if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
  //     return 0;
  //   });

  //   console.log(sortedData, "sortedData");

  //   setSortConfig({ key: key, direction: direction });
  //   setProfitReportRows(sortedData);
  //   setRenderPage(!renderPage);
  // };
  console.log(profitReportDataTable, "profitReportDataTable");

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    console.log(event.target.value, "event");
    const filteredRows =
      profitReportDataTable &&
      profitReportDataTable.length > 0 &&
      profitReportDataTable
        .filter(
          (row) =>
            row &&
            row.modelName &&
            row.modelName
              .toLowerCase()
              .includes(event.target.value.toLowerCase())
        )
        .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates
    console.log(filteredRows, "filteredRows");
    setSearch(event.target.value);
    if (event.target.value == "") {
      setProfitReportRows(profitReportDataTable);
    } else {
      setProfitReportRows(filteredRows);
    }
    // setTableLoading(true);
    // setTimeout(() => {
    //   setTableLoading(false);
    // }, 2000);
  };

  //Total functionality

  const emptyProfitReport =
    profitReportRows &&
    profitReportRows.length > 0 &&
    profitReportRows[0].saleInvoiceNo;

  const itemDiscount =
    emptyProfitReport && totals && totals.itemDiscount
      ? Number(totals.itemDiscount.toFixed(2)).toLocaleString("en-IN")
      : emptyProfitReport && totals && totals.itemDiscount == 0
      ? 0
      : 0;

  const itemProfit =
    emptyProfitReport && totals && totals.profit
      ? Number(totals.profit.toFixed(2)).toLocaleString("en-IN")
      : 0;
  const itemQty = emptyProfitReport && totals && totals.qty ? totals.qty : 0;

  //search and sale amount
  const totalSaleAmount =
    !isEmpty(search) && emptyProfitReport && totals.sellingPrice
      ? "₹.  " + Number(totals.sellingPrice.toFixed(2)).toLocaleString("en-IN")
      : emptyProfitReport &&
        profitReportTotalObj &&
        profitReportTotalObj.totalSaleAmount
      ? "₹.  " +
        Number(profitReportTotalObj.totalSaleAmount.toFixed(2)).toLocaleString(
          "en-IN"
        )
      : "₹.  " + 0;
  //search and purchase amount
  const totalPurchaseAmount =
    !isEmpty(search) && emptyProfitReport && totals.purchasePrice
      ? "₹.  " + Number(totals.purchasePrice.toFixed(2)).toLocaleString("en-IN")
      : emptyProfitReport &&
        profitReportTotalObj &&
        profitReportTotalObj.totalPurchaseAmount
      ? "₹.  " +
        Number(
          profitReportTotalObj.totalPurchaseAmount.toFixed(2)
        ).toLocaleString("en-IN")
      : "₹.  " + 0;
  //search and return amount
  const totalReturnAmount =
    search !== "" && emptyProfitReport && totals.returnPrice
      ? "₹.  " + Number(totals.returnPrice.toFixed(2)).toLocaleString("en-IN")
      : search !== "" && emptyProfitReport && totals.returnPrice == 0
      ? "₹.  " + 0
      : emptyProfitReport &&
        profitReportTotalObj &&
        profitReportTotalObj.totalReturnAmount
      ? "₹.  " +
        Number(
          profitReportTotalObj.totalReturnAmount.toFixed(2)
        ).toLocaleString("en-IN")
      : "₹.  " + 0;

  console.log(totals, "totals");
  //search and item discount
  const totalItemDiscountAmount =
    !isEmpty(search) && emptyProfitReport && totals.itemDiscount
      ? "₹.  " + Number(totals.itemDiscount.toFixed(2)).toLocaleString("en-IN")
      : !isEmpty(search) && emptyProfitReport && totals.itemDiscount == 0
      ? "₹.  " + 0
      : emptyProfitReport &&
        profitReportTotalObj &&
        profitReportTotalObj.itemDiscountAmount
      ? "₹.  " +
        Number(
          profitReportTotalObj.itemDiscountAmount.toFixed(2)
        ).toLocaleString("en-IN")
      : "₹.  " + 0;
  //search and overall discount
  const totalOverallDiscountAmount =
    !isEmpty(search) && emptyProfitReport
      ? "₹.  " + 0
      : emptyProfitReport &&
        profitReportTotalObj &&
        profitReportTotalObj.overallDiscountAmount
      ? "₹.  " +
        Number(
          profitReportTotalObj.overallDiscountAmount.toFixed(2)
        ).toLocaleString("en-IN")
      : "₹.  " + 0;

  //search profit price and percentage
  // const returnedProfit = Number(totals.profit);
  // const searchProfitPrice =
  //   returnedProfit !== ""
  //     ? Number(totals.sellingPrice - returnedProfit)
  //     : Number(totals.profit);
  const searchProfitPercentage =
    totals.purchasePrice && totals.profit !== ""
      ? Number((totals.profit * 100) / totals.purchasePrice)
      : 0;

  const totalOverallPercentage =
    !isEmpty(search) && emptyProfitReport && searchProfitPercentage
      ? Number(searchProfitPercentage).toFixed(2) + "%"
      : emptyProfitReport &&
        profitReportTotalObj &&
        profitReportTotalObj.totalProfitPercentage
      ? profitReportTotalObj.totalProfitPercentage
      : 0;
  const totalNetProfit =
    !isEmpty(search) && emptyProfitReport && totals.profit
      ? "₹.  " + Number(totals.profit.toFixed(2)).toLocaleString("en-IN")
      : emptyProfitReport &&
        profitReportTotalObj &&
        profitReportTotalObj.netProfits
      ? "₹.  " +
        Number(profitReportTotalObj.netProfits.toFixed(2)).toLocaleString(
          "en-IN"
        )
      : "₹.  " + 0;

  //Download functionality
  const handleDownloadPDF = () => {
    setDownloadLoading(true);

    // Table headers
    const tableData = [
      [
        "S.No",
        "Bill No",
        "Bill Date",
        "Model Name",
        "Customer Name",
        "Purchase Price",
        "Selling Price",
        "Item Discount",
        "Profit",
        "Qty",
        "Total Profit",
      ],
    ];

    setTimeout(() => {
      // Extract and format stock report data
      emptyProfitReport &&
        profitReportRows.forEach((data, index) => {
          tableData.push([
            index + 1,
            data.saleInvoiceNo || "",
            data.salesInvoiceDate
              ? moment(data.salesInvoiceDate).format("DD-MM-YYYY")
              : "",
            data.modelName || "",
            data.partyName || "",
            data.purchasePrice || 0,
            data.sellingPrice || 0,
            data.discountAmount || 0,
            data.profit || 0,
            data.qty ? `${data.qty} PCS` : "0 PCS",
            data.profit || 0,
          ]);
        });

      // Append empty row for spacing
      tableData.push(["", "", "", "", "", "", "", "", "", "", ""]);
      tableData.push(["", "", "", "", "", "", "", "", "", "", ""]);
      tableData.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "TOTAL",
        itemDiscount,
        itemProfit,
        itemQty,
        itemProfit,
      ]);
      tableData.push(["", "", "", "", "", "", "", "", "", "", ""]);
      tableData.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "TOTAL SALE AMOUNT",
        totalSaleAmount,
      ]);
      tableData.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "TOTAL PURCHASE AMOUNT",
        totalPurchaseAmount,
      ]);
      tableData.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "ITEM DISCOUNT",
        totalItemDiscountAmount,
      ]);
      tableData.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "TOTAL DISCOUNT",
        totalOverallDiscountAmount,
      ]);
      tableData.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "TOTAL PROFIT(%)",
        totalOverallPercentage,
      ]);
      tableData.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "TOTAL PROFIT",
        totalNetProfit,
      ]);

      // Convert array to worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(tableData);

      // Adjust column widths for readability
      worksheet["!cols"] = tableData[0].map(() => ({ wch: 8 }));

      // Create a new workbook and add the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

      // Convert workbook to Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });

      saveAs(blob, "Profit_Report.xlsx");

      setDownloadLoading(false);
    }, 2000);
  };

  //window height/width

  //Print

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //date and iconCalendarClasses
  const dateFieldClasses =
    media == "sm"
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[200%] mt-2"
      : media == "xs"
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[125%] mt-2"
      : media == "lg" || media == "md"
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[100%]"
      : windowDimensions.width >= 1500 && windowDimensions.width < 1600
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[138%]"
      : windowDimensions.width >= 1600 && windowDimensions.width < 1700
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[148%]"
      : windowDimensions.width >= 1700 && windowDimensions.width < 1800
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[158%]"
      : windowDimensions.width >= 1800 && windowDimensions.width < 1900
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[168%]"
      : windowDimensions.width >= 1900 && windowDimensions.width < 2000
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[178%]"
      : windowDimensions.width >= 2000
      ? "profit-loss-label rounded-sm border border-1 h-[34px] w-[198%]"
      : "profit-loss-label rounded-sm border border-1 h-[34px] w-[100%]";

  const iconCalendarClasses =
    media == "sm"
      ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
      : media == "xs"
      ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
      : media == "md" || media == "lg"
      ? "top-[2px] text-[16px] right-[3px] text-[#9e9e9e]"
      : windowDimensions.width >= 1500 && windowDimensions.width < 1600
      ? "top-[2px] text-[16px] right-[-58px] text-[#9e9e9e]"
      : windowDimensions.width >= 1600 && windowDimensions.width < 1700
      ? "top-[2px] text-[16px] right-[-78px] text-[#9e9e9e]"
      : windowDimensions.width >= 1700 && windowDimensions.width < 1800
      ? "top-[2px] text-[16px] right-[-98px] text-[#9e9e9e]"
      : windowDimensions.width >= 1800 && windowDimensions.width < 1900
      ? "top-[2px] text-[16px] right-[-118px] text-[#9e9e9e]"
      : windowDimensions.width >= 1900 && windowDimensions.width < 2000
      ? "top-[2px] text-[16px] right-[-138px] text-[#9e9e9e]"
      : windowDimensions.width >= 2000
      ? "top-[2px] text-[16px] right-[-158px] text-[#9e9e9e]"
      : "top-[2px] text-[16px] right-[3px] text-[#9e9e9e]";

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Profit Report (Sales) | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Profit Report (Sales)
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          // (windowDimensions.height >= 700 && windowDimensions.height <= 767) ||
          // (windowDimensions.height > 767 && windowDimensions.height < 830)
          //   ? "profit-loss-reports-large-device"
          //   : windowDimensions.height > 830 && windowDimensions.height < 1000
          //   ? "profit-loss-reports-extra-large-device"
          //   : windowDimensions.height >= 1000 && windowDimensions.height < 1100
          //   ? "profit-loss-reports-infinite-large-device"
          //   : windowDimensions.height >= 1100 && windowDimensions.height < 1200
          //   ? "profit-loss-reports-infinite-extra-large-device"
          windowDimensions.height >= 1000
            ? "profit-loss-reports-infinite-extra-extra-large-device"
            : "profit-loss-reports"
        }
      >
        {/* Filter section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          xl={24}
          xxl={24}
          className="mt-2 pr-4 pl-4 pt-3 pb-2 mb-4 bg-[#ffffff] rounded-md"
        >
          <Row>
            <Col
              md={24}
              lg={24}
              sm={24}
              xs={24}
              xl={24}
              xxl={24}
              className="pr-4 mb-3 flex justify-center"
            >
              <Radio.Group
                className="flex"
                value={profitMode}
                onChange={(e) => setProfitMode(e.target.value)}
              >
                <div className="flex">
                  <Radio value={"Invoice Wise"}></Radio>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1 ml-1"
                  >
                    Invoice Wise
                  </Typography>
                </div>
                <div className="flex ml-[20px]">
                  <Radio value={"Date Wise"}></Radio>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1 ml-1"
                  >
                    Date Wise
                  </Typography>
                </div>
              </Radio.Group>
            </Col>
            <Col span={24} className="">
              <Row className="flex pr-2 pl-2 pt-3 pb-2 rounded-md">
                {profitMode === "Invoice Wise" ? (
                  <div className="w-[100%] mb-4 flex">
                    <Col
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      sm={24}
                      xs={24}
                      className="pr-3"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "250px",
                            height: "34px",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <ReactSearchAutocomplete
                          name="barcode"
                          key={profitClear}
                          items={invoiceListOptions}
                          value={profitList}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onChange={(e) => setProfitList(e.target.value)}
                          onSelect={(e) => {
                            setProfitList(e);
                            console.log(e, "profitList");
                          }}
                          showClear
                          placeholder="Scan invoice"
                          fuseOptions={fuseOptions} // Search on both fields
                          className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                          styling={{
                            height: "32px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            textAlign: "end",
                            hoverBackgroundColor: "lightgray",
                            color: "black",
                            // marginBottom: "-3px",
                            fontSize: "12px",
                            fontFamily: "Poppins",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      )}
                    </Col>
                    <Col
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      sm={24}
                      xs={24}
                      className="pr-2"
                    >
                      <Row
                        className={
                          media == "sm" || media == "xs" ? "flex" : "flex"
                        }
                      >
                        {loading ? (
                          <Skeleton.Input
                            style={{
                              width:
                                media == "md"
                                  ? "180px"
                                  : media == "sm"
                                  ? "300px"
                                  : "250px",
                              height: "35px",
                            }}
                          ></Skeleton.Input>
                        ) : (
                          <div className="flex">
                            <div
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "13px",
                              }}
                              onClick={() => resetInvoiceFilters()}
                              className={
                                media == "sm" || media == "xs"
                                  ? "cursor-pointer ml-0 text-[#ffffff] text-center pt-[6px] rounded-sm pb-[6px] pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                                  : "cursor-pointer ml-5 text-[#ffffff] text-center pt-[6px] rounded-sm pb-[6px] pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                              }
                            >
                              Reset
                            </div>
                            <div
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "13px",
                              }}
                              onClick={() => applyFilters()}
                              className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-sm pt-2 pb-2 pl-5 pr-5 bg-[#11a962e0] hover hover:bg-[#085832]"
                            >
                              {tableLoading ? "Loading..." : "Filter"}
                            </div>
                          </div>
                        )}
                      </Row>
                    </Col>
                  </div>
                ) : (
                  <div className="w-[100%] mb-4 flex">
                    {" "}
                    <Col
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      sm={24}
                      xs={24}
                      className="pr-3"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "250px",
                            height: "35px",
                            marginTop:
                              media == "sm" || media == "xs" ? "6px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <DatePicker
                          selected={fromDate}
                          className={dateFieldClasses}
                          toggleCalendarOnIconClick={true}
                          onChange={(date) => setFromDate(date)}
                          icon={<BiCalendar className={iconCalendarClasses} />}
                          popperClassName={"z-10 ml-3"}
                          showIcon
                          placeholderText="Select From Date"
                        />
                      )}
                    </Col>
                    <Col
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      sm={24}
                      xs={24}
                      className="pr-3"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "250px",
                            height: "35px",
                            marginTop:
                              media == "sm" || media == "xs" ? "6px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <DatePicker
                          selected={toDate}
                          className={dateFieldClasses}
                          toggleCalendarOnIconClick={true}
                          onChange={(date) => setToDate(date)}
                          icon={<BiCalendar className={iconCalendarClasses} />}
                          popperClassName={"z-10 ml-3"}
                          showIcon
                          placeholderText="Select To Date"
                        />
                      )}
                    </Col>
                    <Col
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      sm={24}
                      xs={24}
                      className="pr-3"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "250px",
                            height: "35px",
                            marginTop:
                              media == "sm" || media == "xs" ? "6px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Select
                          value={customerList}
                          onChange={(value, option) => {
                            // setCustomerList(e);
                            setCustomerList({ value, label: option.label });
                          }}
                          placeholder="Select Customer"
                          options={customerOptions}
                          suffixIcon={
                            !isEmpty(customerList) ? (
                              <CloseCircleOutlined
                                onClick={() => setCustomerList([])}
                              />
                            ) : (
                              <DownOutlined />
                            )
                          }
                          allowClear
                          style={{
                            border: "1px solid lightgray",
                            borderRadius: "2px",
                          }}
                          bordered={false}
                          // menuItemSelectedIcon
                          onClear={() => setCustomerList([])}
                          className={
                            media == "sm"
                              ? "w-[366px] h-[34px] mt-2"
                              : media == "xs"
                              ? "w-[230px] h-[34px] mt-2"
                              : "w-[100%] h-[34px]"
                          }
                          rootClassName="text-[12px] profit-loss-label"
                        />
                      )}
                    </Col>
                    <Col
                      md={5}
                      lg={5}
                      xl={5}
                      xxl={5}
                      sm={24}
                      xs={24}
                      className="pr-2"
                    >
                      <Row
                        className={
                          media == "sm" || media == "xs" ? "flex" : "flex"
                        }
                      >
                        {loading ? (
                          <Skeleton.Input
                            style={{
                              width:
                                media == "md"
                                  ? "180px"
                                  : media == "sm"
                                  ? "300px"
                                  : "250px",
                              height: "35px",
                            }}
                          ></Skeleton.Input>
                        ) : (
                          <div className="flex">
                            <div
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "13px",
                              }}
                              onClick={() => resetFilters()}
                              className={
                                media == "sm" || media == "xs"
                                  ? "cursor-pointer ml-0 text-[#ffffff] text-center pt-[6px] rounded-sm pb-[6px] pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                                  : "cursor-pointer ml-5 text-[#ffffff] text-center pt-[6px] rounded-sm pb-[6px] pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                              }
                            >
                              Reset
                            </div>
                            <div
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "13px",
                              }}
                              onClick={() => applyFilters()}
                              className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-sm pt-2 pb-2 pl-5 pr-5 bg-[#11a962e0] hover hover:bg-[#085832]"
                            >
                              {tableLoading ? "Loading..." : "Filter"}
                            </div>
                          </div>
                        )}
                      </Row>
                    </Col>
                  </div>
                )}
              </Row>
            </Col>
          </Row>
        </Col>

        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className="bg-[#ffffff] rounded-md"
        >
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-1 pb-3">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={24}
                  xs={24}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        width:
                          media == "md"
                            ? "180px"
                            : media == "sm"
                            ? "300px"
                            : "180px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div className="w-[100%] lg:w-[65%] md:w-[65%]">
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input
                          placeholder="Search Model"
                          style={{
                            fontFamily: "Poppins",
                            borderRadius: "4px",
                            border: "1px solid lightgray",
                            fontSize: "11px",
                          }}
                          className="h-[34px] profit-loss-label w-[70%]"
                          addonAfter={<SearchOutlined className="pt-[6px]" />}
                          name="search"
                          bordered={false}
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col
                  md={14}
                  lg={14}
                  xl={14}
                  xxl={14}
                  sm={24}
                  xs={24}
                  className="pr-4 flex justify-end"
                >
                  <Row
                    className={media == "sm" || media == "xs" ? "flex" : "flex"}
                  >
                    {loading ? (
                      <Skeleton.Input
                        style={{
                          width:
                            media == "md"
                              ? "180px"
                              : media == "sm"
                              ? "300px"
                              : "250px",
                          height: "35px",
                        }}
                      ></Skeleton.Input>
                    ) : (
                      <div className="flex">
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                          onClick={() => {
                            setProfitPrint(true);
                            setTimeout(() => {
                              setProfitPrint(false);
                            }, 4000);
                          }}
                          className={
                            media == "sm" || media == "xs"
                              ? "cursor-pointer ml-0 border border-1 text-center pt-[8px] rounded-md pb-[8px] pl-6 pr-6 mr-2 bg-[#ffffff] hover hover:bg-[#ffffff]"
                              : "cursor-pointer ml-5 border border-1 text-center pt-[8px] rounded-md pb-[8px] pl-6 pr-6 mr-2 bg-[#ffffff] hover hover:bg-[#ffffff]"
                          }
                        >
                          <ReactToPrint
                            trigger={() => (
                              <div
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="track-wider flex justify-center text-start"
                              >
                                {profitPrint ? (
                                  <p className="flex">
                                    <Spin className="mr-2" /> Loading
                                  </p>
                                ) : (
                                  <div className="flex text-[14px] profit-loss-label">
                                    <PrinterFilled className="cursor-pointer text-[16px] mr-1" />
                                    Print
                                  </div>
                                )}
                              </div>
                            )}
                            delay={1500}
                            content={() => printProfitRef.current}
                          />
                        </div>
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                          onClick={handleDownloadPDF}
                          className="cursor-pointer text-[14px] profit-loss-label ml-1 border border-1 text-center pt-[8px] rounded-md pb-[8px] pl-6 pr-6 mr-2 bg-[#ffffff] hover hover:bg-[#ffffff]"
                        >
                          {downloadLoading ? (
                            <p className="flex">
                              <Spin className="mr-2" /> Exporting
                            </p>
                          ) : (
                            <div className="flex">
                              <FileExcelOutlined /> Export to Excel{" "}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
            {/* profit table */}

            <Col
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              sm={24}
              xs={24}
              className={media === "xxl" ? "pl-4 pr-4" : "pr-1 pl-4 pr-4"}
              ref={printProfitRef}
              style={{
                marginTop: profitPrint ? "10px" : "",
              }}
            >
              <div
                className={
                  profitPrint
                    ? "profit-loss-print-table-responsive-reports  border border-1 rounded-md border-lightgray-500"
                    : "profit-loss-table-responsive-reports border border-1 rounded-md border-lightgray-500"
                }
              >
                <table className="w-[100%] profit-table table-responsive">
                  <thead className="w-[100%]">
                    <tr className="w-[100%] profit-table-activities-head-main">
                      <th
                        className={
                          profitPrint
                            ? "w-[3%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[3%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        S.No
                        {/* <div className="flex" onClick={() => handleSort("key")}>
                          <h1>S.No</h1>
                          <p className="ml-1 mt-[-2px]">
                            {sortConfig.key === "key"
                              ? sortConfig.direction === "asc"
                                ? "↑"
                                : "↓"
                              : "↓"}
                          </p>
                        </div> */}
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-[8%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[8%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Bill No
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-[10%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[10%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Bill Date
                      </th>
                      {/* <th className="w-[18%] capitalize profit-table-head text-[14px] font-semibold">
                        Brand
                      </th> */}
                      <th
                        className={
                          profitPrint
                            ? "w-[16%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[16%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Model Name
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-[10%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[10%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Customer Name
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-[12%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[12%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Purchase Price
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-11%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[11%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Selling Price
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-[8%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[8%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Item Discount
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-[8%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[8%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Profit
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-[5%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[5%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Qty
                      </th>
                      <th
                        className={
                          profitPrint
                            ? "w-[10%] capitalize profit-table-head text-[12px] font-semibold"
                            : "w-[10%] capitalize profit-table-head text-[14px] font-semibold"
                        }
                      >
                        Total Profit
                      </th>
                    </tr>
                  </thead>
                  <tbody className="mb-8">
                    {profitReportRows &&
                    profitReportRows.length > 0 &&
                    profitReportRows[0].saleInvoiceNo ? (
                      profitReportRows.map((data, index) => {
                        return (
                          <tr
                            key={index}
                            className={
                              profitPrint
                                ? "mt-2 profit-table-response profit-table-row border border-b-1 border-x-0 border-t-0"
                                : "profit-table-row border border-b-1 border-x-0 border-t-0"
                            }
                          >
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2 text-center"
                                  : "profit-table-data p-1 text-center"
                              }
                            >
                              {index + 1}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2"
                                  : "profit-table-data p-1"
                              }
                            >
                              {data.saleInvoiceNo
                                ? data.saleInvoiceNo
                                : data.saleInvoiceNo}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2"
                                  : "profit-table-data p-1"
                              }
                            >
                              {data.salesInvoiceDate
                                ? moment(data.salesInvoiceDate).format(
                                    "DD-MM-YYYY"
                                  )
                                : ""}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2"
                                  : "profit-table-data p-1"
                              }
                            >
                              {data.modelName ? data.modelName : ""}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2"
                                  : "profit-table-data p-1"
                              }
                            >
                              {data.partyName ? data.partyName : ""}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2 text-end"
                                  : "profit-table-data p-1 text-end"
                              }
                            >
                              {data && data.purchasePrice
                                ? Number(
                                    data.purchasePrice.toFixed(2)
                                  ).toLocaleString("en-IN")
                                : 0}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2 text-end"
                                  : "profit-table-data p-1 text-end"
                              }
                            >
                              {data && data.sellingPrice
                                ? Number(
                                    data.sellingPrice.toFixed(2)
                                  ).toLocaleString("en-IN")
                                : 0}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2 text-end"
                                  : "profit-table-data p-1 text-end"
                              }
                            >
                              {data && data.discountAmount
                                ? Number(
                                    data.discountAmount.toFixed(2)
                                  ).toLocaleString("en-IN")
                                : 0}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2 text-end"
                                  : "profit-table-data p-1 text-end"
                              }
                            >
                              {data && data.profit
                                ? Number(data.profit.toFixed(2)).toLocaleString(
                                    "en-IN"
                                  )
                                : ""}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2 text-end"
                                  : "profit-table-data p-1 text-end"
                              }
                            >
                              {data.qty ? data.qty + " PCS" : 0 + " PCS"}
                            </td>
                            <td
                              className={
                                profitPrint
                                  ? "profit-table-data p-2 text-end"
                                  : "profit-table-data p-1 text-end"
                              }
                            >
                              {data && data.profit
                                ? Number(data.profit.toFixed(2)).toLocaleString(
                                    "en-IN"
                                  )
                                : 0}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr key={0}>
                        <td className="text-center" colSpan={12}>
                          No data found..
                        </td>
                      </tr>
                    )}
                    <tr className="profit-table-row font-semibold ">
                      <td
                        colSpan={6}
                        className="p-4 text-end profit-table-total-amount-data uppercase font-semibold text-[12px]"
                      ></td>
                      <td className="p-4 text-end profit-table-total-amount-data uppercase font-semibold text-[12px]"></td>
                      <td className="p-4 text-end profit-table-total-amount-data uppercase font-semibold text-[12px]"></td>
                      <td className="p-4 profit-table-total-amount-data text-end"></td>
                      <td className="p-4 profit-table-total-amount-data text-end"></td>
                      <td className="p-4 profit-table-total-amount-data text-end"></td>
                    </tr>
                    {/* total  */}
                    <tr className="bg-[#b3ebb5c7]] profit-table-row font-semibold">
                      <td
                        colSpan={6}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[13px]"
                      >
                        {"Total"}
                      </td>
                      <td className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"></td>
                      <td className="text-[13px] profit-table-total-amount-data p-2 text-end">
                        <p
                          className="ml-4 text-[13px]"
                          style={{
                            fontFamily: "Roboto",
                          }}
                        >
                          {itemDiscount}
                        </p>
                      </td>
                      <td className="text-[13px] text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]">
                        <p
                          className="ml-4 text-[13px]"
                          style={{
                            fontFamily: "Roboto",
                          }}
                        >
                          {itemProfit}
                        </p>
                      </td>
                      <td className="text-[13px] profit-table-total-amount-data p-2 text-end">
                        <p className="">{itemQty}</p>
                      </td>
                      <td className="text-[13px] profit-table-total-amount-data p-2 text-end">
                        <p
                          className="ml-4 text-[13px]"
                          style={{
                            fontFamily: "Roboto",
                          }}
                        >
                          {itemProfit}
                        </p>
                      </td>
                    </tr>
                    {/* Total Sale amount */}
                    <tr className="bg-[#12b76a1c] profit-table-row font-semibold ">
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        Total Sale Amount
                      </td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        <div className="flex justify-end w-[100%]">
                          <p
                            className="ml-4 text-[16px]"
                            style={{
                              fontFamily: "Roboto",
                            }}
                          >
                            {totalSaleAmount}
                          </p>
                        </div>
                      </td>
                    </tr>
                    {/* Total Purchase amount */}
                    <tr className="bg-[#12b76a1c] profit-table-row font-semibold ">
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        Total Purchase Amount
                      </td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        <div className="flex justify-end w-[100%]">
                          <p
                            className="ml-4 text-[16px]"
                            style={{
                              fontFamily: "Roboto",
                            }}
                          >
                            {totalPurchaseAmount}
                          </p>
                        </div>
                      </td>
                    </tr>
                    {/* Total Purchase amount */}
                    <tr className="bg-[#12b76a1c] profit-table-row font-semibold ">
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        Total Return Amount
                      </td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        <div className="flex justify-end w-[100%]">
                          <p
                            className="ml-4 text-[16px]"
                            style={{
                              fontFamily: "Roboto",
                            }}
                          >
                            {totalReturnAmount}
                          </p>
                        </div>
                      </td>
                    </tr>
                    {/* Total Item Discount */}
                    <tr className=" bg-[#12b76a1c] profit-table-row font-semibold ">
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        Item Discount
                      </td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        <div className="flex justify-end w-[100%]">
                          <p
                            className="ml-4 text-[16px]"
                            style={{
                              fontFamily: "Roboto",
                            }}
                          >
                            {totalItemDiscountAmount}
                          </p>
                        </div>
                      </td>
                    </tr>
                    {/* Total Discount */}
                    <tr className="bg-[#12b76a1c] profit-table-row font-semibold ">
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        Total Discount
                      </td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        <div className="flex justify-end w-[100%]">
                          <p
                            className="ml-4 text-[16px]"
                            style={{
                              fontFamily: "Roboto",
                            }}
                          >
                            {totalOverallDiscountAmount}
                          </p>
                        </div>
                      </td>
                    </tr>
                    {/* Net Profit */}
                    <tr className="bg-[#8ab0e39e] net-profit-above-table-row font-semibold ">
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        Total Profit (%)
                      </td>
                      <td
                        colSpan={4}
                        className="text-end text-[14px] profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        {" "}
                        {totalOverallPercentage}
                      </td>
                    </tr>

                    {/* Net Profit */}
                    <tr className="net-profit-above-table-row font-semibold ">
                      <td
                        colSpan={4}
                        className="p-[3px] text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={4}
                        className="p-[3px] text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={4}
                        className="p-[3px] text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                    </tr>
                    {/* Net Profit */}
                    <tr className="p-5 profit-table-row font-semibold ">
                      <td
                        colSpan={4}
                        className="text-end profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      ></td>
                      <td
                        colSpan={8}
                        className="bg-[#ff1111ab] text-[black] text-center profit-table-total-amount-data uppercase p-2 font-semibold text-[12px]"
                      >
                        <div className="flex justify-center w-[100%]">
                          {" "}
                          <h1 className="text-[18px]">NET PROFIT</h1>
                          <p
                            className="ml-4 text-[18px]"
                            style={{
                              fontFamily: "Roboto",
                            }}
                          >
                            {totalNetProfit}
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

ProfitLossReport.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default ProfitLossReport;
